import axios from 'axios';
import { Dayjs } from 'dayjs';

export default class SeasonService {
  getSeasons = async () => {
    try {
      const response = await axios.get(`/pl-season?$orderby=label desc`);
      if (response.data) {
        return {
          ...response.data,
        };
      }
      return null;
    } catch (error) {
      console.error('Error in getSeasons:', error);
      throw error;
    }
  };

  updateSeasonAgmDate = async (id: string, agmDate: Dayjs | null) => {
    try {
      const response = await axios.patch(`/pl-season/${id}`, {
        // build the UTC-midnight instant for the exact calendar date shown in the picker, rather
        // than agmDate.toISOString() - which converts the LOCAL midnight instant to UTC and would
        // shift the date by an hour (and across midnight during BST) depending on the local offset
        agmDate: agmDate
          ? `${agmDate.format('YYYY-MM-DD')}T00:00:00.000Z`
          : null,
      });
      if (response.data) {
        return {
          ...response.data,
        };
      }
      return null;
    } catch (error) {
      console.error('Error in updateSeasonAgmDate:', error);
      throw error;
    }
  };
}
